import { Spin } from 'antd';
import moment from 'moment';
import {
  Axis,
  Chart,
  Coord,
  Geom,
  Guide,
  Label,
  Legend,
  Shape,
  Tooltip,
  View
} from 'bizcharts';
import {Pagination} from 'antd';
import en_us from 'rc-pagination/lib/locale/en_US';
import zh_cn from 'rc-pagination/lib/locale/zh_CN';
import { ENGLISH, PATH_HOME } from '../../utils/constants';
import { routerRedux } from 'dva/router';

const contrastChart = (detailData, intl) => {
  let d = [];
  let valueMax = 0;
  detailData &&
    detailData.forEach(item => {
      d.push({
        bookNum: intl.formatMessage({ id: 'report_roomDetail_bookNum' }),
        dayNum: `${moment(item.startDate).format('D')}`,
        times: item.bookNum
      });
      valueMax =
        valueMax > Number(item.bookNum) ? valueMax : Number(item.bookNum);
    });
  detailData &&
    detailData.forEach(item => {
      d.push({
        bookNum: intl.formatMessage({ id: 'report_roomDetail_unSignNum' }),
        dayNum: `${moment(item.startDate).format('D')}`,
        times: item.noSignNum
      });
      valueMax =
        valueMax > Number(item.noSignNum) ? valueMax : Number(item.noSignNum);
    });

  const cols = {
    dayNum: {
      alias: intl.formatMessage({ id: 'report_roomDetail_dayNum' })
    },
    times: {
      alias: intl.formatMessage({ id: 'report_roomDetail_num' })
    }
  };
  if (valueMax < 5) {
    cols['times'].min = 0;
    cols['times'].max = 5;
    cols['times'].ticks = [1, 2, 3, 4, 5];
  }
  return (
    <Chart height={350} data={d} scale={cols} forceFit>
      <Axis
        name="dayNum"
        title={{ textStyle: { fill: '#333' } }}
        label={{ textStyle: { fill: '#333' } }}
      />
      <Axis
        name="times"
        title={{ textStyle: { fill: '#333' } }}
        label={{ textStyle: { fill: '#333' } }}
        position="bottom"
      />
      <Legend
        offsetY={-320}
        offsetX={320}
        marker={'circle'}
        textStyle={{
          fill: '#ff0000',
          stroke: '#333'
        }}
      />
      <Tooltip crosshairs={{ type: 'line' }} />
      {d.length > 2 && (
        <Geom
          type="area"
          position="dayNum*times"
          color={['bookNum', ['#99ff00', '#ffcc00']]}
        />
      )}
      {d.length > 2 && (
        <Geom
          type="line"
          position="dayNum*times"
          size={2}
          color={['bookNum', ['#99ff00', '#ffcc00']]}
        />
      )}
      {d.length <= 2 && (
        <Geom
          type="line"
          position="dayNum*times"
          size={2}
          color={['bookNum', ['#99ff00', '#ffcc00']]}
        />
      )}
      {d.length <= 2 && (
        <Geom
          type="point"
          position="dayNum*times"
          size={2}
          shape={'circle'}
          color={['bookNum', ['#99ff00', '#ffcc00']]}
          style={{ stroke: '#fff', lineWidth: 1 }}
        />
      )}
    </Chart>
  );
};

const occupyChart = (detailData, intl) => {
  let d = [];
  detailData &&
    detailData.forEach(item => {
      d.push({
        dayNum: `${moment(item.startDate).format('D')}`,
        percent: item.usage
      });
    });
  const cols = {
    percent: {
      tickInterval: 100,
      alias: intl.formatMessage({ id: 'report_percent' })
    },
    dayNum: { alias: intl.formatMessage({ id: 'report_roomDetail_dayNum' }) }
  };
  return (
    <Chart height={350} data={d} scale={cols} forceFit>
      <Axis
        title={{ textStyle: { fill: '#333' } }}
        label={{ textStyle: { fill: '#333' } }}
        name="dayNum"
      />
      <Axis
        title={{ textStyle: { fill: '#333' } }}
        label={{ textStyle: { fill: '#333' } }}
        position="top"
        name="percent"
      />
      <Tooltip crosshairs={{ type: 'line' }} />
      {d.length > 1 && (
        <Geom type="area" position="dayNum*percent" color="#33cccc" />
      )}
      {d.length <= 1 && (
        <Geom type="point" position="dayNum*percent" color="#33cccc" />
      )}
      <Geom type="line" position="dayNum*percent" size={2} color="#33cccc" />
    </Chart>
  );
};
const allHours = resourceAuth => {
  let startTime = (resourceAuth && resourceAuth.startTime) || '';
  let endTime = (resourceAuth && resourceAuth.endTime) || '';
  let end = endTime.split(':')[0];
  let start = startTime.split(':')[0];
  let result = Number(end) - Number(start);
  return { result, start };
};

const generateHead = (hours, start, intl) => {
  let s = [];
  for (let i = 0; i < hours; i++) {
    let m = Number(start) + i;
    if (Number(m) < 10) {
      m = '0' + m;
    }
    s.push(<li className="itemtime">{`${m}:00`}</li>);
  }
  return (
    <div className="userTimes">
      <div className="timeText head-title">
        {intl.formatMessage({ id: 'report_date' })}
      </div>
      <ul className="timeheadItem head-title">{s}</ul>
    </div>
  );
};

let extendMinutes = minutes => {
  let m = 0;
  if (minutes <= 15 && minutes > 0) {
    m = 15;
  } else if (minutes <= 30 && minutes > 0) {
    m = 30;
  } else if (minutes <= 45 && minutes > 0) {
    m = 45;
  }
  return m;
};
// hpurs是顶部总的小时, start是开始的小时数, meeting的开始时间和结束时间不足不能被15整初的向后补齐来做
const indexArrOfTimes = (hours, start, meeting) => {
  let startHour = moment(meeting.startTime).hour();
  let endHour = moment(meeting.endTime).hour();
  let startTime = moment(meeting.startTime).minute();
  let extendStartTime = extendMinutes(startTime);
  let endTime = moment(meeting.endTime).minute();
  let extendEndTime = extendMinutes(endTime);
  if (extendEndTime === 0 && endTime > 30 && endTime < 45) {
    endHour = endHour + 1;
  }
  // startIndex 是对应到热力图中的会议开始的 index
  let startIndex = (startHour - Number(start)) * 4 + extendStartTime / 15;
  let endIndex = (endHour - Number(start)) * 4 + extendEndTime / 15;
  let interval = endIndex - startIndex;
  let m = [];
  for (let i = 0; i < interval; i++) {
    m.push(startIndex + i);
  }
  return m;
};

const generateBody = (keyName, data, hours, start) => {
  let len = data.length;
  // colorArr 是算出要显示的下标数字
  let colorArr = [];
  if (len !== 0) {
    // 这里要根据 value 来进行判断具体是哪一小块来决定显示的颜色
    data.forEach((item, index) => {
      let arr = indexArrOfTimes(hours, start, item);
      colorArr.push(arr);
    });
  }
  // let value = data[year]
  let s = [];
  for (let i = 0; i < hours * 4; i++) {
    let newStyle = '';
    if (colorArr.length !== 0) {
      colorArr.forEach(item => {
        item.forEach(colorIndex => {
          if (colorIndex === i) {
            newStyle = 'item-blue';
          }
        });
      });
    }
    s.push(<li className={`body-itemtime ${newStyle}`} />);
  }
  return (
    <div className="userTimes userTimesTable">
      <div className="timeText">{keyName}</div>
      <ul className="timeheadItem ">{s}</ul>
    </div>
  );
};

const hotChart = (useTimes, userTimesData, intl) => {
  let { resourceAuth } = useTimes;
  let { result, start } = allHours(resourceAuth);
  let arr = Object.keys(userTimesData);
  let body = [];
  arr.forEach((item, index) => {
    let m = generateBody(item, userTimesData[item], result, start);
    body.push(m);
  });
  let s = generateHead(result, start, intl);
  return (
    <div>
      {s}
      {body}
    </div>
  );
};

export default ({ loading, roomReportDetails, intl, dispatch }) => {
  let { meetingName = '' } = roomReportDetails;
  const detailData =
    (roomReportDetails.details.data && roomReportDetails.details.data.list) ||
    [];
  const useTimes = roomReportDetails.useTimes.data || {};
  const userTimesData = roomReportDetails.userTimesData;
  return (
    <div className="message-body roomDetail">
      <div className="messages-first roomDetailHeader">
        <div className="nav">
          <a>{intl.formatMessage({ id: 'report_roomDetail_title' })}</a>
        </div>
        <button
          onClick={() => {
            dispatch(
              routerRedux.push({
                pathname: `${PATH_HOME}roomReport`,
                query: { detail: true }
              })
            );
          }}
        >
          {intl.formatMessage({ id: 'report_roomDetail_back' })}
        </button>
      </div>
      <Spin spinning={loading} size="large">
        <div className="messages-list">
          <div className="roomDetailName">{meetingName}</div>
          <div className="detailchartTitle">
            {intl.formatMessage({ id: 'report_roomDetail_chart' })}
          </div>
          {contrastChart(detailData, intl)}
        </div>
        <div className="messages-list ">
          <div className="detailchartTitle">
            {intl.formatMessage({ id: 'report_roomDetail_detail' })}
          </div>
          {occupyChart(detailData, intl)}
          <div className="page-cont">
            <Pagination
              size="small"
              total={
                (roomReportDetails.details.data &&
                  roomReportDetails.details.data.total) ||
                0
              }
              pageSize={roomReportDetails.pageSize}
              current={roomReportDetails.pageNo || 1}
              onChange={p => {
                dispatch({
                  type: 'roomReportDetails/changePage',
                  payload: { pageNo: p }
                });
              }}
              locale={
                intl.formatMessage({ id: 'locale' }) === ENGLISH ? en_us : zh_cn
              }
            />
          </div>
        </div>
        {roomReportDetails.useTimes &&
          roomReportDetails.useTimes.data && (
            <div className="messages-list">
              <div className="detailchartTitle">
                {intl.formatMessage({ id: 'report_occupancy_detail' })}
              </div>
              {hotChart(useTimes, userTimesData, intl)}
              <div className="page-cont">
                <Pagination
                  size="small"
                  total={roomReportDetails.userTimesLen || 0}
                  pageSize={roomReportDetails.userTiemsPageSize}
                  current={roomReportDetails.userTimesPageNo || 1}
                  onChange={p => {
                    dispatch({
                      type: 'roomReportDetails/changeUserTimesPage',
                      payload: { userTimesPageNo: p }
                    });
                  }}
                  locale={
                    intl.formatMessage({ id: 'locale' }) === ENGLISH
                      ? en_us
                      : zh_cn
                  }
                />
              </div>
            </div>
          )}
      </Spin>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/RoomReportDetails.js